<template lang="pug">
.article-wraper
    moreTab(:showOperation="showOperation"
        :popType="popType"
            @operationEvent="operation"
            @fatherMethod="callMe"
            :data="data"
            :popData="popData")
    postBox(:data="data"
            :postData="postData"
            @fatherMethod="callMe"
            v-if="showPostBox")
    .article
        .nav
            span.back(@click="goBack")
                i.iconfont &#xe65f;
            span.page(@click="showPop('pager',pagesList)")
                span {{ curPage + '/'+ totalPages }}
                i.iconfont.active &#xe630;
            span.more(@click="showPop('operation')") ···
        .title
            h1 {{article.title}}
            .ainfo
                span 浏览 {{article.see_num}}
                span 评论 {{article.reply_num}}
        .author
            .uinfo
                .avatar(@click="appCall('openPersonalPage',[article.uid])")
                    img(:src="jInfo.authorAvatar")
                .name
                    strong(:test-class="data.authorInfo.isVip ? 'vipName' : ''"
                        :class="data.authorInfo.isVip ? 'vipName' : ''"
                    ) {{article.username}}

                        i(:class="'vericon ' + authorVerifyClass")
                    .time {{jInfo.time}}

            .follow-area
                div(:class="'follow ' + ( data.isAttend == true ? ' followed ' : '' )"
                v-if=" jInfo.curUid != article.uid "
                    @click="follow")
                    template(v-if="data.isAttend") 已关注
                    template(v-else)
                        i.iconfont.icon-jia
                        template 关注

        .content#js-art-cont(
            @click="helper.contentClick($event , '#js-art-cont' , data.shareData)"
                v-lazy-container="{ selector: '.preimg' }"
            )

            .wrap(v-html="helper.fixRichText(article._data2show.appContent)")
            p.second-hand-tips(v-if="article.group_id==25")
                i.iconfont.icon-gantanhao &#xe64f;
                | 二手交易有风险，买卖双方交易需谨慎，小心资金财产损失！
            .ad-img(v-if="data.ad_img != ''")
                img(:src="data.ad_img")
            .tips {{article.tips}}
            .popular
                .oper
                    a.share(@click="share")
                        i.iconfont &#xe61c;
                        template 分享
                    a(:class="'praise ' + ( data.isPraise == 1 ? 'active' : '' ) " @click="praise('article')" href="javascript:;")
                        i.iconfont &#xe61a;
                        template {{data.praiseNum}}

        .comment-tab#commentTab
            div.leftbtn
                a(:class="owner==0?'active' : '' " @click="viewOwner(false)") 全部评论
                a(:class="owner==1?'active' : '' " @click="viewOwner") 楼主
            div(@click="setOrder" :class="'rightbtn ' + (order=='asc'?'':' desc')")
                span {{order=='asc' ? '顺序查看' : '倒序查看'}}
                i.iconfont.icon-droparrow
        .comment
            ul.list
                li.item(v-if="defaultNoReply" @click="articleReply")
                    .empty 还没有回帖，我来发布一个！
                li.item(v-for="(item,index) in replyList")
                    .u-info
                        span.avatar(@click="appCall('openPersonalPage',[item.uid])")
                            img(:src="item.userimg")
                        span.uname {{item.username}}
                        span.uicon(v-if="item.verifyClass != ''")
                            i(:class="'vericon ' + item.verifyClass")
                        span.utime {{item.time}}
                        span.fl
                            font {{ item.floor+'楼'}}
                    .cont(@click="helper.contentClick($event , '#rel' + item.id , data.shareData , function(){reply(item.id , item.username)})"
                        :id="'rel' + item.id")
                        .c
                            .rcont(v-html="helper.fixReplyContent(item.content)")
                            .rcont-img(v-if="item.image.length>0")
                                .img-item(v-for="commentImg in item.image")
                                    img(:src="commentImg.mall")
                            .c-comments(v-if="item.childComment.length > 0")
                                .cd-comment(v-for="(cdItem,cdFloor) in item.childComment")
                                    .cd-uinfo
                                        span.username {{cdItem.contactname}}
                                        span.date {{cdItem.date}}
                                        span.area(v-if="1>2") {{cdItem.city}}
                                        span.floor(v-if="1>2") {{(cdFloor+1) + '#'}}
                                    .cd-comment-cont(@click.stop="reply(cdItem.id , cdItem.contactname)")
                                        span.replyTo(v-if="cdItem.replytousername!=''") 回复 {{cdItem.replytousername}}:
                                        | {{cdItem.message}}

                    .tool
                        span.report(@click="showPop('report',{type:'post',infoid:item.id})")
                        span(@click="praise('reply',item.id,index)" :class="item.isPraise==1?'like liked' : 'like'" )
                            i.iconfont &#xe61a;
                            font {{item.praise_num}}
            div.rub(v-if="replyLoading == true && reachedEnd == false")
                .loading
                    i.icon
                    span 正在加载中...
            div.rub(v-if="reachedEnd")
                .loading
                    span 已经到底了
        .bottom-reply
            .wrap
                .cont(@click="articleReply" )
                    i.iconfont &#xe683;
                    span 发表评论 ...
                .house
                    i(:class="'star ' + (data.isHouse == 1 ? 'praised' : '')" @click="house()")
                    i.share(@click="share")
        .fix-btn
            a.go-top(@click="goToTop" v-if="showGoToTopBtn")
                i.iconfont.icon-arrowtop
            a.edit(v-if="jInfo.curUid==article.uid" @click="edit")  修改
            a.edit(@click="showPop('manage',{article:article})" v-if="data.isAdmin")  管理
</template>

<script>
    import $ from "jquery";
    import moreTab from "../components/moreTab.vue"
    import appHelper from "../lib/appHelper"
    import articleHelper from "../lib/articleHelper";
    import utils from "../lib/util"
    import postBox from "../components/post.vue";
    import appCall from "../lib/AppCall";

    export default {
        name: 'Article',
        components : {
            moreTab , postBox
        },
        data () {
            return {
                //从页面上获取的属性
                data : {},
                article : {},
                jInfo : {},
                appCall : appCall,
                replyList : [],

                //通过上面的属性计算出来的属性
                totalPages : 1,
                curPage : 1,
                pagesList : {},
                order : "asc",
                owner : 0,
                authorVerifyClass : '',     //认证图标class

                //控制UI界面的相关属性
                showOperation : false,
                showGoToTopBtn : false,
                popType : "operation",
                popData : {},
                postData : {},
                replyLoading : false,
                reachedEnd : false,
                helper : articleHelper,
                isSupWep : articleHelper.isSupWebp(),
                defaultNoReply : false,
                showPostBox : false,
                //环境判断
                isInApp : false,
                isInWeChat : false,
            }
        },
        mounted : function(){
            setTimeout(function(){
                $('.globalLoading').hide();
            } , 500);
        },
        beforeMount : function(){

            window.replyFinished = function () {
                utils.reloadPage();
            };

            //打开原生界面
            var _jdata = JSON.stringify({
                "id" :  window.article.id,
                "closePreWindow" : "1"
            });
            if ( window.jInfo.noNative == '' ){
                appCall("openWindow", ['circleNative',_jdata]);
            }

            //先注册一个时间
            appHelper.pipe('regEvent',['login_success']);
            //原生触发的事件
            window.triggerEvent = function(event,d){
                if (event == 'login_success'){
                    utils.reloadPage();
                }
            }

            let a = document.getElementsByName("base")[0].innerHTML;
            let data = {} , mThis = this;
            try{
                data = JSON.parse(a);

                this.authorVerifyClass = this.comVerIconClass(data.authorInfo);
            } catch (e){
                alert('bad json');
            }
            console.log(data);
            this.data = data;

            let checkApp = appHelper.checkApp();
            this.isInApp = checkApp.app;
            this.isInWeChat = checkApp.weChat;


            this.article = window.article;
            this.jInfo = window.jInfo;

            //加载下一页 postData
            articleHelper.bodyScrollBottom(function(){
                mThis.loadPage('next');
            } , function(scrollTop){
                if (scrollTop >= 600 ){
                    mThis.showGoToTopBtn = true;
                } else {
                    mThis.showGoToTopBtn = false;
                }
            });

            this.loadPage(1);

        },
        methods : {
            /**
             * @param {{display:bool , event : event}} childObject
             **/
            operation : function(childObject){

                if (childObject.event == undefined ||
                    $(childObject.event.target).hasClass('van-popup') ){
                    this.showOperation = childObject.display;
                }
                console.log('not in pop');
            },

            /**
             * 服务端给的 page对象，会把总页数为1  设置为 0
             * @param {{page:Int,page_total:Int}} pageObject
             **/
            fixPage : function( pageObject ){

                if (pageObject.page_total === 0){
                    pageObject.page_total = 1;
                }
                return pageObject;

            },
            goBack : function(){
                if (this.isInApp){
                    appCall("closeWindow");
                } else {
                    history.back();
                }
            },

            /**
             * @param {{isVip:bool , zmtType : int , zmtTypeName : String}} zmtObject
             **/
            comVerIconClass : function( zmtObject ){
                let ret = `ver${zmtObject.zmtType}`;
                if (zmtObject.isVip){
                    ret += "vip";
                }
                return ret;
            },

            showPop : function(t,data){
                //分页时，有关闭功能
                if ( t == 'pager'){
                    this.showOperation = this.showOperation == true ? false : true;
                } else {
                    this.showOperation = true;
                }
                this.popType = t;
                this.popData = data;
            },

            showArticleReport : function(){
                this.showPop('report' , {
                    type : "article",
                    infoid : this.article.id
                });
            },
            /**
             * @param page
             */
            loadPage : function ( page ) {

                //等上一次加载完
                if (this.replyLoading == true){
                    console.log('Loading,skipReLoading!!');
                    return;
                }
                if (this.reachedEnd == true && isNaN(page)){
                    console.log('reached LastPge!');
                    return;
                }

                if (isNaN(page)){
                    this.curPage++;
                } else {
                    this.curPage = page;
                }

                if (this.curPage > this.totalPages ){
                    this.curPage = this.totalPages == 0 ? 1 : this.totalPages;
                    this.reachedEnd = true;
                    return;
                }
                let mThis = this;

                this.replyLoading = true;

                let queryType = this.owner == 0 ? 'all' : 'self';
                $.getJSON(`/reply/reply-list.html?articleId=${this.article.id}&page=${this.curPage}&orderType=${this.order}&queryType=${queryType}&netstatus=1`,function(data){
                    mThis.replyLoading = false;

                    if (data.type != 'succ'){
                        alert(data.msg);
                        return;
                    }
                    if (data.msg.list.length == 0){
                        mThis.reachedEnd = true;
                        return;
                    }

                    var newReplyList = articleHelper.fixReplyItem( data.msg.list , mThis.curPage  ,
                        data.msg.page.total , mThis.order);

                    mThis.totalPages = data.msg.page.pagetotal;


                    if (isNaN(page)){
                        mThis.replyList = mThis.replyList.concat(newReplyList);
                    } else {
                        mThis.replyList = newReplyList;
                    }

                    console.log(mThis.replyList);


                    for(var x = 1 ; x<= mThis.totalPages ; x++){
                        mThis.pagesList[x] = `第${x}页`;
                    }
                });
            },
            contentClick : function(event){
                console.log(event);
                articleHelper.contentClick(event);
            },
            callMe : function(funcName){
                this.showOperation = false;
                if (typeof funcName === 'string'){
                    this[funcName]();
                    return;
                } else if (typeof  funcName === 'object'){
                    this[funcName.method](funcName.data);
                }

                if (Array.isArray(funcName.addOnMethods)){
                    let methods = funcName.addOnMethods;
                    for(let x in methods){
                        this[methods[x]]();
                    }
                }
            },
            share : function(){
                let sData = this.data.shareData;
                let shareParams = [
                    sData.desc, sData.desc, sData.thumb,
                    sData.title,sData.url,sData.desc];
                appCall("showSharePopup" , shareParams)
                .notApp((info)=>{
                    if (info.isWeChat){
                        alert('请使用微信界面 右上角的 菜单 分享本页面 ^_-~ ');return;
                    }
                })
                .notSupport((info)=>{
                    alert("你需要更新APP才能继续操作哦！");
                });
            },
            viewOwner : function(setOn){
                this.data.replyList.list = [];
                this.curPage = 1;
                this.reachedEnd = false;

                if (setOn == false){
                    this.owner = 0;
                    this.loadPage(1);
                } else {
                    this.owner = 1;
                    this.loadPage(1);
                }
            },
            setOrder : function(){
                this.order = this.order == 'asc' ? 'desc' : 'asc';
                this.data.replyList.list = [];
                this.curPage = 1;
                this.reachedEnd = false;
                    this.loadPage(1);

            },

            follow : function(){
                let mThis = this;
                if (!appHelper.checkAppLogin()) {
                    return false;
                }
                $.post(`/members/attention.html` , {
                    attentionUid :this.article.uid
                },function(rep){
                    if (!utils.resolveRep(rep)){
                        return false;
                    }
                    mThis.data.isAttend = mThis.data.isAttend ? false : true;

                },'JSON');
            },
            house : function(){
                $.getJSON(`/article/house.html?id=${this.data.articleId}`);
                this.data.isHouse =  this.data.isHouse == 1 ? 0 : 1;
            },
            praise : function( type , replyId , itemListKey ){

                if (!appHelper.checkAppLogin()) {
                    return false;
                }

                if ( type == 'article'){
                    replyId = this.data.articleId;
                    if (this.data.isPraise == 1){
                        this.data.praiseNum --;
                        this.data.isPraise = 0;
                    } else {
                        this.data.praiseNum ++;
                        this.data.isPraise = 1;
                    }
                } else {
                    if (this.replyList[itemListKey].isPraise == 0 ){
                        this.replyList[itemListKey].praise_num ++
                        this.replyList[itemListKey].isPraise = 1;
                    } else {
                        this.replyList[itemListKey].praise_num --
                        this.replyList[itemListKey].isPraise = 0;
                    }
                }

                $.getJSON(`/article/praise.html?type=${type}&id=${replyId}`,function(data){
                    utils.resolveRep(data);
                });
            },

            articleReply : function(){

                let mThis = this;
                if (!appHelper.checkAppLogin()) {
                    return false;
                }
                if (mThis.data.replyable != 1) {
                    appHelper.alert(mThis.data.replyableMsg);
                    return;
                }

                var bridgeJSON = JSON.stringify({
                    article_id: mThis.data.articleId,
                    callback: 'replyFinished'
                });
                appCall("showAppComment",[bridgeJSON])
                .notApp(()=>{
                    mThis.showPost(true );
                }).notSupport(()=>{
                    alert("你需要更新APP才能继续操作哦！");
                });
            },
            edit : function(){
                let json = JSON.stringify({
                    type : "edit",
                    id : this.article.id
                });
                appCall("openWindow",['postCircle',json])
                .notApp(()=>{
                    alert('抱歉！请在爱羽客APP内或者PC端进行修改帖子！');
                });
            },
            /**
             * @param display
             */
            showPost : function( display , addOnData ){
               this.showPostBox = display;
               this.postData = addOnData;
            },

            goToTop: function(){
                window.scrollTo(0,0);
            },

            goToComment : function(){
                window.scrollTo(0 , document.getElementById('commentTab').offsetTop - 50 )

            },
            reply : function( id , username ){
                let mThis = this;
                if (!appHelper.checkAppLogin()) {
                    return ;
                }
                // 点击到其他区域就回复此条回复
                if (this.data.replyable != 1) {
                    appHelper.alert(this.data.replyableMsg);
                    return;
                }
                let bridgeJSON = JSON.stringify({
                    article_id: mThis.data.articleId,
                    parent_reply_id: id,
                    parent_reply_name: username ,
                    callback: 'replyFinished'
                });
                appCall("showAppComment",[ bridgeJSON ])
                .notApp(()=>{
                    mThis.showPost(true , {
                        id : id ,
                        username : username
                    });
                }).notSupport(()=>{
                    appHelper.alert("你需要更新APP才能继续操作哦！");
                });
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/modules/article.vue